// extracted by mini-css-extract-plugin
export default {"container":"default-controls_container__8Kh9V","fullscreen":"default-controls_fullscreen__5Vbjo"};